<template>
  <Loading v-if="loading" />
  <div class="changeLang">
    <div class="changeLang__title">
      <p class="title">
        {{ $t('lang') }}
      </p>
    </div>
    <FormKit
      id="lang-form"
      v-model="formData"
      type="form"
      :actions="false"
      @submit="submitHandler"
    >
      <Dropdown
        class="dropdown-lang"
        :selected-option="langsDropdown.selectedOption"
        :options="langsDropdown.options"
        :label="$t('desktopLang')"
        @select-option="selectLanguage"
      />
    </FormKit>
    <Button
      class="changeLang-btn"
      variant="filled"
      :title="$t('save')"
      @click="submitForm"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

import {
  langsEn,
  langsFi,
  langsSv,
  langsNo,
  langsLv,
  langsSl,
  optionsLanguageEn,
  optionsLanguageFi,
  optionsLanguageSv,
  optionsLanguageNo,
  optionsLanguageLv,
  optionsLanguageSl
} from '@/services/languageService';
import { Option } from '@/types';

@Options({
  name: 'ChangeLang',
  components: {
    Loading
  },
  data() {
    return {
      formData: {
        lang: ''
      },
      langsDropdown: {
        selectedOption: {
          label: '',
          value: ''
        },
        options: []
      },
      loading: false
    };
  },
  computed: {
    ...mapState('account', ['user'])
  },
  methods: {
    ...mapActions('account', ['changeLang', 'getUserProfile']),
    initLanguage() {
      const optionsMappings: { [key: string]: Option[] } = {
        en: optionsLanguageEn,
        fi: optionsLanguageFi,
        sv: optionsLanguageSv,
        no: optionsLanguageNo,
        lv: optionsLanguageLv,
        sl: optionsLanguageSl
      };

      const userLanguage = this.user?.appLanguage;

      if (userLanguage && optionsMappings[userLanguage]) {
        this.langsDropdown.options = optionsMappings[userLanguage];
      }
    },
    selectLanguage(option: Option) {
      this.langsDropdown.selectedOption = option;
    },
    async submitHandler() {
      this.loading = true;

      const payload = {
        lang: this.langsDropdown.selectedOption.value
      };

      await this.changeLang(payload);
      await this.getUserProfile();
      this.$i18n.locale = this.langsDropdown.selectedOption.value;
      this.$formkit.reset('lang-form');
      this.loading = false;
    },
    submitForm() {
      this.$formkit.submit('lang-form');
    }
  },
  watch: {
    user() {
      if (this.user && this.user.appLanguage) {
        this.initLanguage();
        const langs = {
          en: langsEn,
          fi: langsFi,
          sv: langsSv,
          no: langsNo,
          lv: langsLv,
          sl: langsSl
        };

        const language = this.user.appLanguage as keyof typeof langs;

        this.langsDropdown.selectedOption = {
          label: langs[language][language],
          value: this.user.appLanguage
        };
      }
    }
  }
})
export default class ChangeLang extends Vue {}
</script>

<style lang="scss" scoped>
.changeLang {
  .changeLang__title {
    position: relative;
    margin-top: 40px;
    margin-bottom: 32px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $sixteenSize;
      color: $main-text;
    }
    &::after {
      content: '';
      position: absolute;
      top: 9px;
      left: 80px;
      width: 100%;
      height: 1px;
      background: $ligher-grey;
    }
    &::before {
      content: '';
      position: absolute;
      top: 7px;
      left: 80px;
      width: 5px;
      height: 5px;
      border-radius: 8px;
      background: $ligher-grey;
    }
  }
  .formkit-form {
    .dropdown-lang {
      height: 48px;
      width: 375px;
      .dropdown {
        height: 46px;
      }
    }
  }
  .changeLang-btn {
    margin-top: 30px;
  }
}
</style>
